import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import User from '../views/User'
import Main from '../views/Main'
import Login from '../views/Login'
import UpdatePassword from '../views/UpdatePassword'
import UpdatePrivateAside from '../views/UpdatePrivateAside'
import AccountList from '../views/AccountList'
import EditUser from '../views/EditUser.vue'
import EditProxy from '../views/EditProxy.vue'
import SetScore from '../views/SetScore.vue'
import SetScoreLog from '../views/SetScoreLog.vue'
import QueryReport from '../views/QueryReport.vue'
import AllQueryReport from '../views/AllQueryReport.vue'
import UserSearch from '../views/UserSearch.vue'
import AdminUpdatePwd from '../views/AdminUpdatePwd.vue'
import UserIdPool from '../views/UserIdPool.vue'
import NotFound from '../views/NotFound.vue'

var router = new Router({
  mode: 'hash',
  // base: '.',
  routes: [
        {
          path: '/',
          name: 'Main',
          component: Main,
          redirect: "/accountList",
          children: [
            {
              path: '/updatePassword',
              name: 'updatePassword',
              component: UpdatePassword,
            },
            {
              path: '/updatePrivateAside',
              name: 'updatePrivateAside',
              component:UpdatePrivateAside,
            },
            {
              path: '/accountList',
              name: 'accountList',
              component:AccountList,
            },
            {
              path: '/editUser',
              name: 'editUser',
              component:EditUser,
            },
            {
              path: '/editProxy',
              name: 'editProxy',
              component:EditProxy,
            },
            {
              path: '/setScore',
              name: 'setScore',
              component:SetScore,
            },
            {
              path: '/setScoreLog',
              name: 'setScoreLog',
              component:SetScoreLog,
            },
            {
              path: '/queryReport',
              name: 'queryReport',
              component:QueryReport,
            },
            {
              path: '/allQueryReport',
              name: 'allQueryReport',
              component:AllQueryReport,
            },
            {
              path: '/userSearch',
              name: 'userSearch',
              component:UserSearch,
            },
            {
              path: '/userIdPool',
              name: 'userIdPool',
              component:UserIdPool,
            },
            {
              path: '/adminUpdatePwd',
              name: 'adminUpdatePwd',
              component:AdminUpdatePwd,
            },
          ]
        },
        {
          path: '/login',
          name: 'login',
          component:Login
        },
        {
          path: '*',
          name: 'notFound',
          component: NotFound
        },
  ]
})

Vue.use(Router)

router.beforeEach((to, from,next) => {
  // ...
  // console.log(to)
  // if(to.path == "/playerBetLog"){
  //   to.meta.keepAlive=true
  // }
  // if(from.path =="/playerBetLog"){
  //   if (to.path=="")
  // }
  // 返回 false 以取消导航
  var token = localStorage.getItem('token')
  if (!token && to.name !== 'login') {
    next({name: 'login'})
  } else {
    next()
  }
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js